import React from "react";
import numeral from "numeral";
import { Form, InputNumber } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormInputNumber = (props) => {
  // -------------------------- VAR -----------------------------
  const label = props.label || "Tiêu đề";
  const name = props.name || "Tên";
  const placeholder = props.placeholder || "Nhập Tiêu đề";
  const className = props?.className || "";
  const rules = props?.rules || [];
  const min = props?.min || 0;
  const max = props?.max || 9999999999999999;
  const step = props?.step || 1;
  const precision = props?.precision || 0;
  const addonBefore = props?.addonBefore || null;
  const addonAfter = props?.addonAfter || null;
  const width = props?.width || 150;
  const style = props?.style || {};
  const disabled = props?.disabled || false;
  const variant = props?.variant || "outlined";

  const format = renderFormat(precision);
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item className={className} name={name} label={label} rules={rules}>
      <InputNumber
        style={{ width, ...style }}
        min={min}
        max={max}
        step={step}
        // precision={precision}
        disabled={disabled}
        placeholder={placeholder}
        addonAfter={addonAfter}
        addonBefore={addonBefore}
        variant={variant}
        formatter={(v) => numeral(v).format(`0,0${format}`)}
      />
    </Form.Item>
  );
};
export default FormInputNumber;

const renderFormat = (precision) => {
  if (!precision) {
    return "";
  }

  const formatArr = new Array(precision).fill("0");
  const format = `.${formatArr?.join("")}`;
  return format;
};
